'use strict';
module.exports = x => (
	x instanceof Promise ||
	(
		x !== null &&
		typeof x === 'object' &&
		typeof x.then === 'function' &&
		typeof x.catch === 'function'
	)
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/p-is-promise/index.js
// module id = ../node_modules/p-is-promise/index.js
// module chunks = 5